<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.qualityItem.new')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd">
              <span>{{$t('tlt.productionResult')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityItem">
              <span>{{$t('tlt.qualityItem.list')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityItem/edit">
              <span>{{$t('tlt.qualityItem.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('qualityItem')"
          >
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">确定</span>
          </button>
          <!-- <button class="btn btn-primary" type="button" v-on:click="validateForm"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>Save</span></button> -->
          <!-- <button
            class="btn btn-primary"
            type="button"
            v-on:click="QualityItemSave('qualityItemDetails')"
          >
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">Save</span>
          </button> -->
        </div>
      </div>
    </div>

    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemCode')}}:
                </label>
                <input
                  id="itemCode"
                  v-validate="'required'"
                  name="itemCode"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('itemCode') }"
                  v-model="itemCode"
                  type="text"
                />
                <span v-show="errors.has('itemCode')" class="lbl-obg">{{ errors.first('itemCode') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemName')}}:
                </label>
                <input
                  id="itemName"
                  v-validate="'required'"
                  name="itemName"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('itemName') }"
                  v-model="itemName"
                  type="text"
                />
                <span v-show="errors.has('itemName')" class="lbl-obg">{{ errors.first('itemName') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemCraftType')}}:
                </label>
                <select id="craftType" class="form-control" type="text" v-model="craftType">
                  <option value>{{ $t("lbl.basic.select.one") }}</option>
                  <option value="p">{{$t("lbl.qualityItem.pelletizing")}}</option>
                  <option value="s">{{$t("lbl.qualityItem.smelt")}}</option>
                </select>
                <span
                  v-show="errors.has('craftType')"
                  class="lbl-obg"
                >{{ errors.first('craftType') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemCheckType')}}:
                </label>
                <select id="checkType" class="form-control" type="text" v-model="checkType">
                  <option value>{{ $t("lbl.basic.select.one") }}</option>
                  <option value="material">{{$t("lbl.qualityItem.material")}}</option>
                  <option value="process">{{$t("lbl.qualityItem.process")}}</option>
                  <option value="production">{{$t("lbl.qualityItem.production")}}</option>
                </select>
                <span
                  v-show="errors.has('checkType')"
                  class="lbl-obg"
                >{{ errors.first('checkType') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemDetails.parameterCode')}}:
                </label>
                <!--可以改为dimsearch-->
                <dimsearch
                  validate="required"
                  name="parameterCode"
                  v-model="parameterId"
                  :entity="parameters"
                  bindId="parameter"
                  bindProp="parameterCode"
                  submitProp="id"
                ></dimsearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemDetails.parameterName')}}:
                </label>
                <!--可以改为dimsearch-->
                <dimsearch
                  validate="required"
                  name="parameterName"
                  v-model="parameterId"
                  :entity="parameters"
                  bindId="parameter"
                  bindProp="parameterName"
                  submitProp="id"
                ></dimsearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemDetails.parameterUnit')}}:
                </label>
                <!--可以改为dimsearch-->
                <dimsearch
                  validate="required"
                  name="parameterUnit"
                  v-model="parameterId"
                  :entity="parameters"
                  bindId="parameter"
                  bindProp="parameterUnit"
                  submitProp="id"
                ></dimsearch>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemDetails.measureUp')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="measureUp"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('measureUp') }"
                  v-model="measureUp"
                  type="text"
                />
                <span
                  v-show="errors.has('measureUp')"
                  class="lbl-obg"
                >{{ errors.first('measureUp') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualityItemDetails.measureDown')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="measureDown"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('measureDown') }"
                  v-model="measureDown"
                  type="text"
                />
                <span
                  v-show="errors.has('measureDown')"
                  class="lbl-obg"
                >{{ errors.first('measureDown') }}</span>
              </div>
              <div class="col-lg-12 align-self-end">
                <div class="float-lg-right">
                  <button
                    class="btn btn-primary"
                    type="button"
                    v-on:click="QualityItemSave('qualityItemDetails')"
                  >
                    <i class="fa fa-fw fa-lg fa-save"></i>
                    <span class="text">Save</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div id="qualityItemResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table entity="qualityItemDetails"  :singleChoice="true"></mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 260px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import MmfTable from "@/components/MmfTable";
import dimsearch from "@/components/MMFDimSearch";
import { fields } from "@/model/prd/qualityMgt/qualityItemConfig/QualityItemDetails";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityItemDetails/getField",
  mutationType: "qualityItemDetails/updateField"
});

export default {
  name: "qualityItemAdd",
  data() {
    return {
      parameters: []
    };
  },
  components: { MmfTable, dimsearch },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields([...fields, "rows", "entity"])
    // ...mapState({
    //   rows: state => state.qualityItemDetails.rows,

    //   entity: state => state.qualityItemDetails.entity,

    // })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave", "MMFClearFilter"]),
    ...mapActions("qualityItemDetails", ["Save"]),
    clearFilter(entity) {
      let { itemCode, itemName, craftType, checkType } = this.entity;
      let result = { itemCode, itemName, craftType, checkType };
      console.log(result);
      this.clearDimSearch();
      this.$store.commit(entity + "/" + "setEntity", result, { root: true });
    },
    clearAllFilter(entity) {
      this.$store.commit(entity + "/" + "setNewEntity", {}, { root: true });
      this.clearDimSearch();
      this.rows = [];
    },
    clearDimSearch() {
      // this.$store.dispatch(
      //   "dimSearch/initBind",
      //   {
      //     parameter: {}
      //   },
      //   { root: true }
      // );
    },
    QualityItemSave(module) {
      var entityAux = this.$store.state[module]["entity"];

      this.Save(module).then(() => {
        this.clearFilter(module);
      });
      this.entity = entityAux;
      //TODO: 待修复
      document.getElementById("itemCode").disabled = true;
      document.getElementById("itemName").disabled = true;
      document.getElementById("craftType").disabled = true;
      document.getElementById("checkType").disabled = true;
    }
  },
  created() {
    this.$store
      .dispatch(
        "api/get",
        {
          url:
            this.$store.state.qualityItem.baseModuleUrl +
            "/qualityParameter/findAll"
        },
        {
          root: true
        }
      )
      .then(data => {
        this.parameters = data;
      });
    this.clearAllFilter("qualityItemDetails");
  }
};
</script>
